import React, { useState, useEffect } from "react";

// import { Link } from "react-router-dom";

import MentionInputStyle from './MentionInputStyle';
import { MentionsInput, Mention } from 'react-mentions';

const ReportHeaderTableCell = ({cell, mentionVariables, updateCell,rowIndex, columnIndex}) => {

    const cellValue = cell;
    // const [cellValue, setCellValue] = useState(cell);

    const handleMentionChange = (event) => {
        // setCellValue(event.target.value)
        updateCell(event.target.value,rowIndex,columnIndex);
    }

    const mentionStyle = {
      backgroundColor: "rgb(255, 222, 205)",
        borderRadius: "5px",
      padding: 3,
      marginLeft: -3,
      marginRight: -3,
        fontSize: "13px",
        // fontWeight: "bold",
        // color: "white"
    }

    console.log('mentionVariables',mentionVariables)

    return (
      <td>
          <MentionsInput markup='@__type__[__display__](__id__)' value={cellValue} onChange={handleMentionChange} style={MentionInputStyle}>
          <Mention
            trigger="@"
            data={mentionVariables}
            type="reportheader"
            style={mentionStyle}
            singleLine={true}
          />
        </MentionsInput>
      </td>
    );
}

const ReportHeaderTableRow = ({row, rowIndex, mentionVariables, updateCell, inverted}) => {

    let rowNo = rowIndex + 1;
    if (inverted){
      // row number should be a letter; 1 = A, 2 = B, 3 = C,  going to 26 = Z, 27 = AA, 28 = AB, etc like excel
        // change number to base 26
        let base26 = '';
        let num = rowNo;
        while (num > 0){
            let remainder = num % 26;
            num = Math.floor(num / 26);
            if (remainder == 0){
                remainder = 26;
                num--;
            }
            base26 = String.fromCharCode(64 + remainder) + base26;
        }
        rowNo = base26;
    }

    return (
      <tr>
        <td className='row-index'>{rowNo}</td>
        {
          row.map((item,index) => (
            <ReportHeaderTableCell rowIndex={rowIndex} columnIndex={index} key={index} cell={item} mentionVariables={mentionVariables} updateCell={updateCell}/>
          ))
        }
      </tr>
    );
}

export default ReportHeaderTableRow;